export default __webpack_public_path__ + "static/media/akouo-logo-grey.6f6e5fc9.svg";